import React, { useState } from 'react'
import PropTypes from 'prop-types'
import ReactResizeDetector from 'react-resize-detector'

import { resizeAmpIframe } from 'utils/amp'

const ViewportController = ({ children }) => {
  const [seen, setSeen] = useState(false)
  const [position, setPosition] = useState({ x: 0, y: 0 })
  const [size, setSize] = useState({ w: 0, h: 0 })

  const checkWidgetPositioning = () => {
    // If parentIFrame (from iframe-resizer library) is not available yet,
    // wait and try again. It doesn't seem to be available immediately.
    if (!('parentIFrame' in window)) {
      setTimeout(checkWidgetPositioning, 1000)
      return
    }

    // Listen to parent/containing page for scroll and iframe offset information
    // This functionality is provided by the iframe-resizer library
    window.parentIFrame.getPageInfo(({ scrollTop, clientHeight, offsetTop, offsetLeft }) => {
      if (!seen && scrollTop + clientHeight > offsetTop) {
        setSeen(true)
      }

      if (position.x !== offsetLeft || position.y !== offsetTop) {
        setPosition({
          x: offsetLeft,
          y: offsetTop < 0 ? 0 : offsetTop,
        })
      }
    })
  }

  checkWidgetPositioning()

  const onResize = (width, height) => {
    const w = Math.round(width)
    const h = Math.round(height)

    if (w !== size.w || h !== size.h) {
      resizeAmpIframe()
      setSize({ w, h })
    }
  }

  return (
    <>
      <ReactResizeDetector
        onResize={(width, height) => onResize(width, height)}
        handleWidth
        handleHeight
        refreshMode="debounce"
        refreshRate={1000}
      />
      {children({ size, position, seen })}
    </>
  )
}

ViewportController.propTypes = {
  children: PropTypes.func.isRequired,
}

export default ViewportController
